import Gender from "./Gender.mjs";
class Person {
    constructor(name, relationshipType, gender, alive) {
        this._daughters = [];
        this.amountDue = 0;
        this.uuid = Person.lastUsedUuid++;
        this.name = name;
        this.relationshipType = relationshipType;
        this.gender = gender;
        this.alive = alive;
        this._brothers = [];
        this._sisters = [];
        this._sons = [];
        this._spouses = [];
    }
    static resetLastUsedUuid() {
        Person.lastUsedUuid = 0;
    }
    addMother(mother) {
        if (this._mother) {
            console.log("Mother already set");
        }
        this._mother = mother;
    }
    addFather(father) {
        if (this._father) {
            console.log("Father already set");
            return;
        }
        this._father = father;
    }
    addSon(son) {
        this._sons.push(son);
    }
    addDaughter(daughter) {
        this._daughters.push(daughter);
    }
    addBrother(brother) {
        this._brothers.push(brother);
    }
    addSister(sister) {
        this._sisters.push(sister);
    }
    addSpouse(spouse) {
        if (this.gender == Gender.FEMALE && this._spouses.length >= 1) {
            console.log("Cannot have more than one spouse");
            return;
        }
        this._spouses.push(spouse);
    }
}
Person.lastUsedUuid = 0;
export default Person;
